import { useEffect, useState } from "react"
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Paper,
    Grid,
    Box,
    Typography,
    CircularProgress,
    InputAdornment
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import Layout from "../../../../components/appbar_mobile"
import { getOrdersById, getBatchOrders } from "../../../../services/orders"
import { useNavigate, useParams } from "react-router-dom"
import moment from "moment"

const HistoryPage = () => {
    const { order_id } = useParams()
    const role_id = localStorage.getItem('role_id')
    const [order_detail, setOrderDetail] = useState(null)
    const [batch_detail, setBatchDetail] = useState(null)
    const [loading, setLoading] = useState(true)  // เพิ่ม state สำหรับการตรวจสอบสถานะการโหลด

    const token = localStorage.getItem('accessToken')
    localStorage.setItem('redirectAfterLogin', window.location.pathname)

    const navigate = useNavigate()

    useEffect(() => {
        fetchData()
        if (!token) {
            navigate('/login_mobile')
        }
    }, [])

    const fetchData = async () => {
        try {
            setLoading(true)  // เริ่มการโหลดข้อมูล
            let res = await getOrdersById(order_id, token)
            setOrderDetail(res.data.data)
            let res_batch = await getBatchOrders({ order_id: order_id, role_id: 1 }, token)
            setBatchDetail(res_batch.data.data)
        } catch (error) {
            if (error.response?.status === 403) {
                navigate('/login_mobile')
            }
        } finally {
            setLoading(false)  // หลังจากโหลดเสร็จให้ตั้งค่าเป็น false
        }
    }

    return (
        <Layout title={'ข้อมูลค่าสาร'}>
            <Box sx={{ p: 2 }}>
                {/* เช็กสถานะการโหลด */}
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {/* ข้อมูล Lot Summary */}
                        <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography><b>Lot No. : </b>{order_detail?.lot_no ?? "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography><b>น้ำหนักสุทธิ : </b>{Number(order_detail?.total_weight ?? 0).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}  Kgs</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography><b>No. of Farmer : </b> {batch_detail?.length ?? 0}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography><b>วันที่-เวลาเข้า : </b>{moment(order_detail?.delivery_date).format('DD-MM-YYYY')}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                        {batch_detail?.length > 0 ? (
                            batch_detail.map((form, index) => (
                                <Accordion key={index} sx={{ mb: 2 }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="subtitle1">
                                            <b>ID FARMER : {form.agents[0].tag_user_id} = {Number(form.quantity).toLocaleString('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}  kgs</b>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="SKU"
                                                    name="product"
                                                    value={form.product}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="ชื่อเกษตรกร"
                                                    name="owner"
                                                    value={form.agents[0].owner}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="ID Farmer"
                                                    name="farmer_id"
                                                    value={form.agents[0].tag_user_id}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="น้ำหนักรวม"
                                                    name="weight"
                                                    value={form.quantity}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="หัวจุด"
                                                    name="cap_type"
                                                    value={form.owner}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="วันและเวลาที่รับเข้าสินค้า"
                                                    name="receive_date"
                                                    // type="datetime-local"
                                                    value={moment(order_detail?.delivery_date).format('YYYY-MM-DD HH:mm')} // ใช้รูปแบบที่ถูกต้องสำหรับ datetime-local
                                                    disabled={true}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="ค่าความชื้นครั้งที่ 1"
                                                    name="moisture_1"
                                                    value={form.moisture_1}
                                                    disabled={true}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="ค่าสาร Mitragynine ครั้งที่ 1"
                                                    name="mitragynine_1"
                                                    value={form.mitragynine_1}
                                                    disabled={true}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="ค่าความชื้นครั้งที่ 2"
                                                    name="moisture_2"
                                                    value={form.moisture_2}
                                                    disabled={true}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="ค่าสาร Mitragynine ครั้งที่ 2"
                                                    name="mitragynine_2"
                                                    value={form.mitragynine_2}
                                                    disabled={true}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                    </AccordionDetails>
                                </Accordion>
                            ))
                        ) : (
                            <Typography>No farmers data available.</Typography>
                        )}
                    </>
                )}
            </Box>
        </Layout>
    )
}

export default HistoryPage
